<template>
  <div class="px-8 pt-4">
    <div class="text-center py-2">
      <Logo></Logo>
    </div>
    <div class="bg-grey-lighter">
      <div class="">
      </div>
    </div>
    <hr class="bg-grey h-px mt-3 mb-6 opacity-50">
    <div class="mx-auto max-w-md">
      <iframe src="https://societyone.typeform.com/to/I45KE1" width="100%" height="700" frameborder="0" marginheight="0"
              marginwidth="0">Loading...
      </iframe>
    </div>
    <hr class="bg-grey h-px mt-3 mb-6 opacity-50">
    <div>
      <BrokerFooter></BrokerFooter>
    </div>
  </div>
</template>
<script>
import Logo from '@/assets/Logo';
import BrokerFooter from '@/components/BrokerFooter';

export default {
  name: 'Accreditation',
  metaInfo: {
    title: 'Get Accredited With Us | SocietyOne Personal Loans',
  },
  components: {Logo, BrokerFooter},
  mounted() {
    this.$ga.page('/accreditation/');
    this.$gtm.trackView('Accreditation', '/accreditation');
  },
};
</script>
<style scoped>
.badge-position {
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/pages/TomCTOPage2.vue